const { cpLabel } = require('../reportData/customizers/hbCustomizer');

/** "Approximate" maximum number of report-rows per ad-unit/hour in GAM reports when using 'dims' */
const approxComboCount = (dims) => (dims || []).reduce((acc, curr) => acc * curr.approxReportValues(), 1);

/** Create "friendly"/original custom dimension name from name, example: "__sys_Reloading" => "Reloading" */
const fromHbDim = (name) => cpLabel(name.slice(1));

module.exports = {
	approxComboCount,
	fromHbDim,
};
